import { render } from "./AuthenticateSigner.vue?vue&type=template&id=1c88d1e2&scoped=true"
import script from "./AuthenticateSigner.vue?vue&type=script&lang=js"
export * from "./AuthenticateSigner.vue?vue&type=script&lang=js"

import "./AuthenticateSigner.vue?vue&type=style&index=0&id=1c88d1e2&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c88d1e2"]])

export default __exports__